import styled, { css } from 'styled-components/macro';
import { Input } from '../input';

const FOCUS_MS = 160;
export const BLUR_MS = 90;

export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${({ theme }) => theme.semantic.field.icon};
  transition: color ${({ theme }) => theme.tokens.animation.duration.base};

  &:not(:disabled):hover {
    color: ${({ theme }) => theme.semantic.field.iconHover};
  }

  &:disabled {
    cursor: not-allowed;
    /* #586539: icon.disabled = gray.400; смена gray.300 не согласована. */
    color: ${({ theme }) => theme.colors.gray[300]};
  }
`;

export const SwappingInput = styled(Input)<{ $swapping: boolean }>`
  ${({ $swapping }) => css`
    input {
      opacity: ${$swapping ? 0.3 : 1};
      filter: blur(${$swapping ? '2px' : '0'});
      transition:
        opacity ${$swapping ? BLUR_MS : FOCUS_MS}ms ease,
        filter ${$swapping ? BLUR_MS : FOCUS_MS}ms ease;
    }

    @media (prefers-reduced-motion: reduce) {
      input {
        opacity: 1;
        filter: none;
        transition: none;
      }
    }
  `}
`;
